
// core styles
import "assets/css/util.css";
import "assets/scss/argon-dashboard-pro-react.scss?v1.0.0";
import "assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
// plugins styles downloaded
import "assets/vendor/fullcalendar/dist/fullcalendar.min.css";
import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/quill/dist/quill.core.css";
import "assets/vendor/select2/dist/css/select2.min.css";
import "assets/vendor/sweetalert2/dist/sweetalert2.min.css";
import AdminLayout from "layouts/Admin.jsx";
import AuthLayout from "layouts/Auth.jsx";
import SuperAdminLayout from "layouts/SuperAdmin.jsx";
import React from "react";
import ReactDOM from "react-dom";
// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import {Provider} from "react-redux";
// react library for routing
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import IndexView from "views/Index.jsx";
import ProtectedRoute from "./components/auth/ProtectedRoute.jsx";
import "./i18n";
import StatusPageLayout from "./layouts/Status.jsx";
import store from "./store/configureStore";
import xareGrowthProtectedRoutes from "./xareGrowthProtectedRoutes";
import Blog from "./views/Blog";
import KnowledgeCentre2 from "./views/KnowledgeCentre2";
import AboutUs from "./views/AboutUs";
import VersionChecker from "./views/pages/util/VersionChecker";
import Pricing from "./views/Pricing";
import subscribedUserProtectedRoutes from "./subscribedUserProtectedRoutes";
import ReviewSubmission from "./views/ReviewSubmission";
import XareView from "./views/XareView";
import GoogleAnalytics from "./components/googleAnalytics/GoogleAnalytics";
import AuditSubmission from "./views/AuditSubmission";
import AuditResult from "./views/AuditResult";
import Solutions from "./views/Solutions";
import DrivePage from "./views/pages/drive/DrivePage";
import Signup from "./views/Signup";
import CompanyProfile from "./views/CompanyProfile";
import ResetPassword from "./views/ResetPassword.jsx";
import { addUserInfo } from "./actions/auth";
 
 // Handle Local Development Auth Sync (from port 3055)
 if (typeof window !== 'undefined') {
     const params = new URLSearchParams(window.location.search);
     if (params.get('sync_auth') === 'true') {
         const token = params.get('token');
         const roles = params.get('roles');
         const fullName = params.get('fullName');
         const email = params.get('email');
         
         const authData = {
             'CLASHMATE_ACCESS_TOKEN': token,
             'CLASHMATE_ROLE_LIST': roles,
             'CLASHMATE_PERMISSION_LIST': params.get('permissions'),
             'userId': params.get('userId'),
             'email': email,
             'fullName': fullName,
             'tenant': params.get('tenant')
         };
         
         Object.entries(authData).forEach(([key, value]) => {
             if (value) localStorage.setItem(key, value);
         });

         // Also update Redux store to ensure UI (Navbar) updates
         if (fullName && roles) {
             store.dispatch(addUserInfo({
                 fullName,
                 roleList: JSON.parse(roles),
                 username: email
             }));
         }
         
         // Clean up URL
         const newUrl = window.location.pathname + window.location.hash;
         window.history.replaceState({}, '', newUrl);
     }

     // PERSISTENCE: Always ensure Redux store has latest from localStorage on boot
     const token = localStorage.getItem('CLASHMATE_ACCESS_TOKEN');
     const roles = localStorage.getItem('CLASHMATE_ROLE_LIST');
     const fullName = localStorage.getItem('fullName');
     const email = localStorage.getItem('email');

     if (token && roles && fullName) {
         try {
             store.dispatch(addUserInfo({
                 fullName,
                 roleList: JSON.parse(roles),
                 username: email
             }));
         } catch (e) {
             console.error("Failed to restore auth state", e);
         }
     }
 }
 
ReactDOM.render(
    <Provider store={store}>
        <VersionChecker/>
        <BrowserRouter>
            <GoogleAnalytics />
            <Switch>
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/dashboard"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/list"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/admin/create/:tenantUID"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/configuration/:tenantUID"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/admin/show/:adminUID"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/create"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/show/:uniqueId"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/edit/:uniqueId"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/admin/message/list"
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/admin/message/create"
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/admin/message/show/:uniqueId"
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/admin/message/edit/:uniqueId"
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/admin/tenantSetting/list"
                    component={(props) => <AdminLayout {...props} />}
                />
                {xareGrowthProtectedRoutes.map((route) => route)}
                {subscribedUserProtectedRoutes.map((route) => route)}
                {/* Escape routes for migrated pages */}
                <Route exact path="/" render={() => { window.location.href = "/"; return null; }} />
                <Route exact path="/aboutUs" render={() => { window.location.href = "/about-us"; return null; }} />
                <Route exact path="/knowledgeCentre" render={() => { window.location.href = "/knowledge-centre"; return null; }} />
                <Route exact path="/pricing" render={() => { window.location.href = "/pricing"; return null; }} />
                <Route exact path="/xareview" render={() => { window.location.href = "/xareview"; return null; }} />
                <Route exact path="/solutions" render={() => { window.location.href = "/solutions"; return null; }} />
                <Route exact path="/self-assessment" render={() => { window.location.href = "/self-assessment"; return null; }} />

                <Route path="/auth/login" render={(props) => <AuthLayout {...props} />}/>
                <Route exact path="/signup" render={(props) => <Signup {...props} />}/>
                <Route exact path="/drive" render={(props) => <DrivePage {...props} />}/>
                <Route exact path="/self-assessment/:uniqueId" render={(props) => <AuditResult {...props} />}/>
                <Route exact path="/review/:uniqueId" render={(props) => <ReviewSubmission {...props} />}/>
                <Route path="/blog/:uniqueId" render={(props) => <Blog {...props} />}/>
                <Route exact path="/company/:uniqueId" render={(props) => <CompanyProfile {...props} />}/>
                <Route exact path="/resetPassword/:token" render={(props) => <ResetPassword {...props} />}/>
                <Route render={({ location }) => {
                    if (location.pathname.startsWith("/status/")) {
                        window.location.href = location.pathname;
                    } else {
                        window.location.href = "/status/404";
                    }
                    return null;
                }} />
            </Switch>
        </BrowserRouter>
    </Provider>,
    document.getElementById("root")
);
